/* oxlint-disable no-inner-declarations */
import * as rq from '@tanstack/react-query';

import { useDependencies } from '../../contexts/dependencies.context';
import type { ISiteRepository } from '../../domain/repositories/site.repository';
import { GetAllSites } from '../queries/get-all-sites';

export namespace CreateSite {
  export type Input = ISiteRepository.CreateInput;
  export type Output = ISiteRepository.CreateOutput;

  export function useMutation() {
    const queryClient = rq.useQueryClient();
    const { repositories } = useDependencies();

    return rq.useMutation<Output, unknown, Input>({
      mutationFn: (input) => repositories.site.create(input),
      async onSuccess() {
        await queryClient.invalidateQueries({
          queryKey: GetAllSites.key(),
        });
      },
    });
  }
}
